import React from 'react';
import { FiRefreshCw } from 'react-icons/fi';
import { useI18n } from './i18n';

export default function UploadConnectionStatus({ connection }) {
  const { t } = useI18n();
  if (!['retrying','reconnecting','offline'].includes(connection?.state)) return null;
  return <div className="upload-connection-status" role="status">
    <FiRefreshCw className="upload-preparation-spinner" aria-hidden="true" />
    <div><strong>{t(connection.state==='offline' ? 'upload.connectionOffline' : connection.state==='retrying' ? 'upload.connectionRetrying' : 'upload.connectionReconnecting')}</strong>
      <p>{t('upload.connectionResumeHint')}</p></div>
  </div>;
}
